import { getApiUrl, tokenInterceptor } from '@app/api';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const countriesApi = createApi({
  reducerPath: 'countriesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/countries'),
    prepareHeaders: tokenInterceptor,
  }),
  endpoints: (builder) => ({
    getAllCountries: builder.query({
      query: () => ({
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetAllCountriesQuery } = countriesApi;
